import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout, { EmailLink } from "./PolicyLayout";

function Delivery() {
  return (
    <PolicyLayout
      title="shipping & delivery policy"
      intro="This policy explains order processing, tracked delivery, customs, delays, and delivery problems."
    >
      <h2>1. Processing</h2>
      <p>
        Most in-stock orders are prepared for dispatch within 1 business day after payment is confirmed.
        Weekends, public holidays, pre-orders, special-order items, address verification, and unusually
        busy periods can extend processing. Processing time is separate from carrier transit time.
      </p>

      <h2>2. Shipping method and price</h2>
      <p>
        The current checkout offers standard tracked shipping for <strong>$9.99 USD</strong>. Any different
        option or charge will be shown before payment and will control for that order. A tracking event
        may take time to appear after a label is created.
      </p>

      <h2>3. Delivery estimates</h2>
      <p>
        Delivery estimates depend on destination, customs, carrier networks, weather, and local service.
        International orders may take 2–3 weeks in transit in some cases. Estimates are not guaranteed
        delivery dates unless expressly identified as guaranteed. If we cannot dispatch within the time
        promised, we will provide the delay notice and cancellation or refund options required by law.
      </p>

      <h2>4. Delivery areas</h2>
      <p>
        Available destinations appear at checkout. We may be unable to deliver to some post-office boxes,
        remote areas, freight-forwarding services, or locations restricted by a carrier, trade rule, or
        applicable law. An accepted order may be cancelled and refunded if lawful delivery is not possible.
      </p>

      <h2>5. Address accuracy</h2>
      <p>
        Check the complete name, street, unit, city, region, postal code, country, and email before payment.
        Contact us immediately if something is wrong. We cannot promise a change after dispatch. Reasonable
        carrier fees for redirection or reshipment after a customer-provided address error may be charged
        where lawful and disclosed before reshipment.
      </p>

      <h2>6. Customs, taxes, and import duties</h2>
      <p>
        Unless checkout expressly says duties and taxes are included, an international recipient may be
        responsible for import duties, taxes, brokerage, and local handling charges assessed by the
        destination. These charges are not controlled by us. See <Link to="/pricing">Pricing, Taxes &amp; Duties</Link>.
      </p>

      <h2>7. Delivery attempts and unclaimed parcels</h2>
      <p>
        Carriers may require a signature, safe-place instruction, collection, or redelivery booking.
        Monitor tracking and collect a parcel within the carrier’s time limit. If an unclaimed parcel is
        returned, we will contact you about a refund or reshipment. Actual, non-refundable outward or return
        carrier costs may be deducted where the law permits, but mandatory consumer rights remain unaffected.
      </p>

      <h2>8. Lost, delayed, or damaged parcels</h2>
      <p>
        If tracking is overdue, shows delivery you cannot locate, or the parcel arrives damaged, email
        <EmailLink subject="Delivery problem" /> with your order number. Check with household members,
        neighbors, building staff, and the carrier where appropriate. Keep all packaging for a damage
        review. We will investigate and provide the remedy required by applicable law; we will not require
        you to resolve our responsibility solely with the carrier.
      </p>

      <h2>9. Split shipments</h2>
      <p>
        We may split an order when items become available at different times. We will not add an undisclosed
        shipping charge because we choose to split a shipment. Separate tracking numbers may be provided.
      </p>

      <h2>10. Risk and receipt</h2>
      <p>
        Responsibility for loss transfers according to applicable consumer law, usually when you or a person
        you designate receives the goods. Permission to leave a parcel unattended may affect claims where
        local law allows. Report delivery issues promptly so evidence remains available.
      </p>

      <h2>11. Contact</h2>
      <p>
        For shipping questions, email <EmailLink subject="Shipping question" />. For a return after delivery,
        read our <Link to="/returns">Returns &amp; Refund Policy</Link>.
      </p>
    </PolicyLayout>
  );
}

export default Delivery;
